// extracted by mini-css-extract-plugin
export default {"search":"search_search__gnHg1","searchInput":"search_searchInput__WvmHd","icon":"search_icon__qfo0i"};